"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerDropDown = void 0;
const react_1 = __importStar(require("react"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
exports.ManagerDropDown = react_1.default.memo(({ dropdownList, defaultValue, excludeList, handlerUpdateManager, isDisable, }) => {
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    (0, react_1.useEffect)(() => {
        if (value) {
            handlerUpdateManager(value.id);
        }
    }, [value]);
    return (react_1.default.createElement(common_1.DropDown, { className: `dropdown-${isMobile ? 'mini' : 'live'}`, list: dropdownList, excludeList: excludeList, value: value, setDropValue: setValue, styles: {
            itemWrap: {
                padding: '8px 10px',
                top: '45px',
                maxHeight: isMobile ? '200px' : '230px',
            },
        }, isDisable: isDisable }));
});
